// Repair Parts
import FrmRepairPartsIndex from '@/pages/repairs/repairParts/FrmRepairPartsIndex.vue';
import FrmRepairPartsCreatePart from '@/pages/repairs/repairParts/FrmRepairPartsCreatePart.vue';
import FrmRepairPartsDetail from '@/pages/repairs/repairParts/FrmRepairPartsDetail.vue';
import FrmRepairPartsSign from '@/pages/repairs/repairParts/FrmRepairPartsSign.vue';
import FrmRepairPartsFinishReport from '@/pages/repairs/repairParts/FrmRepairPartsFinishReport.vue';

// Repairs Interventions
import FrmRepairsInterventions from '@/pages/repairs/repairsInterventions/FrmRepairsInterventions.vue';

export default [
  // Repair Parts
  {
    path: '/repairs/repairParts',
    component: FrmRepairPartsIndex,
  },
  {
    path: '/repairs/repairParts/createPart',
    component: FrmRepairPartsCreatePart,
  },
  {
    path: '/repairs/repairParts/details',
    component: FrmRepairPartsDetail,
  },
  {
    path: '/repairs/repairParts/sign',
    component: FrmRepairPartsSign,
  },
  {
    path: '/repairs/repairParts/finishReport',
    component: FrmRepairPartsFinishReport,
  },
  // Repairs Interventions
  {
    path: '/repairs/repairsInterventions',
    component: FrmRepairsInterventions,
  },
];
